import { Image } from "../Image";
import {
  RemoteNotification,
  RemoteNotificationFormat,
  RemoteNotificationTrigger,
} from "../RemoteNotification";

export class MockRemoteNotification implements RemoteNotification {
  private static INDEX = 0;

  public id: string;
  public description = "desc";
  public action = "action";
  public link?: string;
  public isNew = false;
  public trigger: RemoteNotificationTrigger = RemoteNotificationTrigger.MANUAL;
  public time = 0;
  public createdAt = "";
  public image?: Image;
  public format: RemoteNotificationFormat = RemoteNotificationFormat.BANNER;
  public linkText = "linkText";
  public title = "title";
  constructor() {
    MockRemoteNotification.INDEX++;
    this.id = `${MockRemoteNotification.INDEX}`;
    this.description = `${MockRemoteNotification.INDEX}`;
  }
}
